import { faBug } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IUnexpectedErrorPageProps {
  message?: string
}

export const UnexpectedErrorPage = React.memo(({ message }: IUnexpectedErrorPageProps) => (
  <FlexBox gap sx={{ "width": "100%", "mt": "3rem", "& .icon": { color: theme => theme.palette.error.main } }}>
    <FontAwesomeIcon icon={faBug} size="3x" className="icon" />
    <Typography color="error" fontSize="1.2rem" fontWeight="600">
      {message ? message : translate("label.error.unexpected")}
    </Typography>
  </FlexBox>
))
